import ImageComparison from 'image-comparison';

export default {
  init() {

    let container = document.querySelectorAll('.before-after');

    Array.prototype.forEach.call(container, (container) => {
      let images = container.querySelectorAll('.before-after__image');

      new ImageComparison({
        container: container,
        startPosition: 50,
        data: [
          {
            image: images[0],
          },
          {
            image: images[1],
          },
        ],
      });
    });
  },

}


// WEBPACK FOOTER //
// ./scripts/blocks/before-after.js